import React, { Component } from 'react'
import i18n from 'i18next'
import { reaction } from 'mobx'
import AnimateHeight from 'react-animate-height'
import { observer } from 'mobx-react'
import { Bar } from 'frontend-charts'

import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import chartRenderSettingsV3 from '../../../DynamicDashV3/chartRenderSettings'
import chartRenderSettings from '../../../DynamicDash/chartRenderSettings'

@observer
class DeviceBrowser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: true,
            updated: new Date().getTime(),
        }

        reaction(
            () => props.reportStore.reportDataFetched,
            () => {
                this.setState({
                    updated: props.reportStore.reportDataFetched,
                })
            },
        )
    }

    toggleOpen = () => {
        const stateCopy = { ...this.state }
        stateCopy.isOpen = !stateCopy.isOpen
        this.setState(stateCopy)
    }

    deviceStats = () => {
        const { reportStore } = this.props
        const { deviceData } = reportStore.reportData

        return (
            <Panel cssClass="question" style={{ flex: 1 }}>
                <PanelHeader>
                    <div style={{
                        padding: '25px', background: '#FAFBFC', display: 'flex', alignItems: 'center', gap: '15px',
                    }}
                    >
                        <div className="surveypage question">
                            <h2 className="reportquestiontitle">
                                {i18n.t('report_devicedatatitle')}
                            </h2>
                        </div>
                    </div>
                </PanelHeader>
                <div style={{ overflowX: 'auto' }}>
                    <table className="datatable tablesorter tablesorter-default" id="datatable_devicetype">
                        <thead>
                            <tr>
                                <th className="tleft tablesorter-header">
                                    {i18n.t('report_devicedata_device')}
                                </th>
                                <th>{i18n.t('report_devicedata_number_of_users')}</th>
                                <th>{i18n.t('report_devicedata_percentage')}</th>
                                <td className="tlast" />
                            </tr>
                        </thead>
                        <tbody>
                            {deviceData.device.map((device, i) => (
                                <tr className="col" key={`device${device}`}>
                                    <th title={device}>{device}</th>
                                    <td>{deviceData.count[i]}</td>
                                    <td>
                                        {deviceData.pct[i].toFixed(2)}
                                        %
                                    </td>
                                    <td className="tlast" />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.chart(deviceData.device, deviceData.pct)}
            </Panel>
        )
    }

    chart = (labels, data) => {
        const { reportStore } = this.props

        const chartData = [{
            name: i18n.t('report_browserdata_percentage'),
            stack: null,
            data: data.reverse().map(parseFloat),
        }]

        const dashStore = {
            appStore: reportStore.appStore,
            benchmarkPeriods: [
                {
                    value: 'ROL36',
                    label: '36 Months',
                    benchmarkType: 'ROL',
                    period: { periodType: 'ROL', duration: 36 },
                    ossPeriod: { periodType: 'last', interval: 'MONTH', duration: 36 },
                },
                {
                    value: 'ROL84',
                    label: 'Long-term',
                    benchmarkType: 'ROL',
                    period: { periodType: 'ROL', duration: 84 },
                    ossPeriod: { periodType: 'last', interval: 'MONTH', duration: 84 },
                },
            ],
            benchmarkPeriod: 'ROL36',
            oId: 6,
            getChartScope: () => 'event',
        }

        const crs = process.env.NEW_WIDGET_CREATOR ? chartRenderSettingsV3 : chartRenderSettings
        const layoutEdits = crs(
            {
                chartType: 'bar',
                scope: 'event',
            },
            dashStore,
            labels,
            chartData,
        )

        const legendPadding = [
            {
                path: ['grid', 'bottom'],
                value: '32',
            },
            {
                path: ['legend', 'padding'],
                value: [
                    5, 5, 0, 5,
                ],
            }]

        return (
            <div style={{ padding: '24px' }} className="chartContainer borderTop">
                <Bar
                    xAxisLabels={labels.reverse()}
                    chartData={chartData}
                    style={{ width: '100%', height: '400px' }}
                    showLegend
                    key="1"
                    tooltipDecimals={0}
                    dataFormat="%"
                    transpose
                    layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding]}
                />
            </div>
        )
    }

    browserStats = () => {
        const { reportStore } = this.props
        const { browserData } = reportStore.reportData
        return (
            <Panel cssClass="question" style={{ flex: 1 }}>
                <PanelHeader>
                    <div style={{
                        padding: '25px', background: '#FAFBFC', display: 'flex', alignItems: 'center', gap: '15px',
                    }}
                    >
                        <div className="surveypage question">
                            <h2 className="reportquestiontitle">
                                {i18n.t('report_browserdatatitle')}
                            </h2>
                        </div>
                    </div>
                </PanelHeader>
                <div style={{ overflowX: 'auto' }}>
                    <table className="datatable tablesorter tablesorter-default" id="datatable_browsertype">
                        <thead>
                            <tr>
                                <th className="tleft tablesorter-header">
                                    {i18n.t('report_browserdata_browser_type')}
                                </th>
                                <th>{i18n.t('report_browserdata_number_of_users')}</th>
                                <th>{i18n.t('report_browserdata_percentage')}</th>
                                <td className="tlast" />
                            </tr>
                        </thead>
                        <tbody>
                            {browserData.browser.map((browser, i) => (
                                <tr className="col" key={`browser_${browser}`}>
                                    <th title={browser}>{browser}</th>
                                    <td>{browserData.count[i]}</td>
                                    <td>
                                        {browserData.pct[i].toFixed(2)}
                                        %
                                    </td>
                                    <td className="tlast" />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.chart(browserData.browser, browserData.pct)}
            </Panel>
        )
    }

    stats = () => (
        <div style={{ display: 'flex', gap: '10px' }}>
            {this.browserStats()}
            {this.deviceStats()}
        </div>
    )

    toggleOpen = () => {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }

    render() {
        const { isOpen } = this.state
        const chevron = isOpen ? 'up' : 'down'
        return (
            <Panel>
                <PanelHeader>
                    <div style={{
                        display: 'flex', padding: '15px', alignItems: 'center', gap: '10px',
                    }}
                    >
                        <i
                            onClick={this.toggleOpen}
                            className={`fa-thin fa-chevron-${chevron}`}
                            style={{
                                color: '#715AFF',
                                backgroundColor: '#F7F5FF',
                                borderRadius: '3px',
                                padding: '10px',
                                cursor: 'pointer',
                            }}
                        />
                        <h4
                            style={{
                                color: '#102E4A',
                                margin: '0px',
                            }}
                        >
                            {i18n.t('report_device_and_browser_stats')}
                        </h4>
                    </div>
                </PanelHeader>
                <AnimateHeight
                    duration={250}
                    height={isOpen ? 'auto' : 0} // see props documentation below
                >
                    <div
                        style={{
                            padding: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '25px',
                        }}
                    >
                        {this.stats()}
                    </div>
                </AnimateHeight>
            </Panel>
        )
    }
}

export default DeviceBrowser
